import React from "react";
import { FaArrowRight } from "react-icons/fa";

export default function ContactForm({ quote = false }) {
  return (
    <form className="contact-form" onSubmit={(event) => event.preventDefault()}>
      <div className="field-row">
        <label>
          Nome completo
          <input required placeholder="O seu nome" />
        </label>
        <label>
          Telefone
          <input required placeholder="+244" />
        </label>
      </div>
      <label>
        Email
        <input type="email" placeholder="nome@email.com" />
      </label>
      {quote && (
        <>
          <label>
            Área de interesse
            <select>
              <option>Formação profissional</option>
              <option>Tecnologia e Cyber</option>
              <option>Gráfica e repografia</option>
              <option>Solução empresarial</option>
            </select>
          </label>
          <div className="field-row">
            <label>
              Quantidade estimada
              <input type="number" min="1" placeholder="Ex.: 20" />
            </label>
            <label>
              Prazo desejado
              <input type="date" />
            </label>
          </div>
        </>
      )}
      <label>
        Mensagem
        <textarea rows="6" placeholder="Explique como podemos ajudar" />
      </label>
      <button className="button button-gold" type="submit">
        Enviar pedido <FaArrowRight />
      </button>
    </form>
  );
}
